// src/modals/LoyerLineModal.jsx — modale d'édition d'une ligne loyer/charges
// dans la vue sous-location (SousLocationView). Champs : libellé, montant.

import { useState } from "react"
import { DS } from "../lib/ui"
import { uid } from "../lib/format"

import useEchapPourFermer from "../lib/useEchapPourFermer"
export default function LoyerLineModal({ line, onSave, onClose }) {
  // Échap ferme — consigne 2026-08-14, hook partagé (pile anti-double-fermeture).
  useEchapPourFermer(onClose)

  const [label, setLabel] = useState(line?.label || "")
  const [montant, setMontant] = useState(String(line?.montant || ""))
  const si = { border:`0.5px solid ${DS.borderHover}`,borderRadius:DS.radiusControl,padding:"9px 12px",width:"100%",fontSize:13,outline:"none",fontFamily:DS.fontBody,background:DS.card }
  const lbl = { fontSize:11,color:DS.textMuted,marginBottom:4,fontWeight:600,textTransform:"uppercase",letterSpacing:.5 }
  return (
    <div style={{position:"fixed",inset:0,background:"rgba(0,0,0,.55)",zIndex:1000,display:"flex",alignItems:"flex-end",justifyContent:"center"}}>
      <div className="fbz-modal-sheet" style={{background:DS.card,borderRadius:"20px 20px 0 0",padding:24,width:"100%",maxWidth:480,fontFamily:DS.fontBody}}>
        <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:18}}>
          <div style={{fontFamily:DS.fontDisplay,fontWeight:600,color:DS.marineDark,fontSize:17}}>{line?.id ? "Modifier" : "Ajouter"} une ligne</div>
          <button onClick={onClose} style={{background:"none",border:"none",fontSize:24,cursor:"pointer",color:DS.textMuted}}>×</button>
        </div>
        <div style={{marginBottom:12}}>
          <div style={lbl}>Libellé</div>
          <input value={label} onChange={e => setLabel(e.target.value)} placeholder="Ex: Loyer nu" style={si} />
        </div>
        <div style={{marginBottom:20}}>
          <div style={lbl}>Montant (€)</div>
          <input type="number" value={montant} onChange={e => setMontant(e.target.value)} placeholder="0.00" style={si} />
        </div>
        <div style={{display:"flex",gap:8}}>
          <button className="fbz-press" onClick={onClose} style={{flex:1,padding:12,background:DS.card,color:DS.marine,border:`0.5px solid ${DS.borderHover}`,borderRadius:DS.radiusControl,fontWeight:600,cursor:"pointer",fontFamily:DS.fontBody}}>Annuler</button>
          <button className="fbz-press" onClick={() => onSave({ id: line?.id || uid(), label, montant: parseFloat(montant) || 0 })}
            style={{flex:2,padding:12,background:DS.corail,color:"#fff",border:"none",borderRadius:DS.radiusControl,fontWeight:700,cursor:"pointer",fontFamily:DS.fontBody}}>Enregistrer</button>
        </div>
      </div>
    </div>
  )
}
